var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104.25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#656dfc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m94.68 5.93 6.07 6.07-6.07 6.07"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M.75 12h100"
  }))));
};
export { SvgArrowRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDQuMjUiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAxMDQuMjUgMjQiPgogIDxnIGlkPSJhcnJvdy1yaWdodCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTUzOS43NSAtMTg4KSI+CiAgICA8cGF0aCBpZD0iVmVjdG9yIiBkPSJNMCwwLDYuMDcsNi4wNywwLDEyLjE0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2MzQuNDMgMTkzLjkzKSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNjU2ZGZjIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ii8+CiAgICA8cGF0aCBpZD0iVmVjdG9yLTIiIGRhdGEtbmFtZT0iVmVjdG9yIiBkPSJNMCwwSDEwMCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTQwLjUgMjAwKSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNjU2ZGZjIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ii8+CiAgICA8cGF0aCBpZD0iVmVjdG9yLTMiIGRhdGEtbmFtZT0iVmVjdG9yIiBkPSJNMCwwSDI0VjI0SDBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2NDQgMjEyKSByb3RhdGUoMTgwKSIgZmlsbD0ibm9uZSIgb3BhY2l0eT0iMCIvPgogIDwvZz4KPC9zdmc+Cg==";